import * as React from 'react';
import Checkbox from '@material/react-checkbox';
import Marker from '../../../../../shop-ui/components/Marker';
import { translate } from 'PyzShopUi/scripts/utils/translate';
import useToggleFilter from '../../../../../shop-ui/components/search-page/hooks/useToggleFilter';
import { IFilterProps } from '../../../../../shop-ui/components/search-page/interfaces';

const NewlyArrivedFilter: React.FunctionComponent<IFilterProps> = props => {
    if (!props.options.length) {
        return null;
    }

    const [isSelected, onToggleFilter] = useToggleFilter(props.name, props.options, props.dispatch);

    return (
        <div onClick={() => onToggleFilter()} className={`toggle-filter`}>
            <Checkbox
                nativeControlId={props.name + '_' + isSelected}
                checked={isSelected}
            />
            <Marker label={translate('New!', 'article-list').toLocaleUpperCase()} color={`blue`}/>
        </div>
    );
};

export default NewlyArrivedFilter;
